<template>
    <div>
        <input type='hidden' v-model='$parent.item.id'>

        <div class="form-group">
            <label for='name'>Title</label>
            <input type='text' v-model='$parent.item.title' class='form-control'>
        </div>

        <div class="form-group">
            <label for='name'>Content</label>
            <textarea v-model='$parent.item.content' class='form-control'></textarea>
        </div>

        <div class="form-group">
            <label for='name'>Start At</label>
            <div class='d-flex flex-row'>
                <datetime2 ref='sadate' v-model="$parent.item.start_at"></datetime2>
            </div>
        </div>

        <div class="form-group">
            <label for='name'>End At</label>
            <div class='d-flex flex-row'>
                <datetime2 ref='eadate' v-model="$parent.item.end_at"></datetime2>
            </div>
        </div>

        <div class="form-group">
            <label>
                Notice
            </label>
            <div>
            <toggle-button sync v-model='$parent.item.notice' :labels="{checked: 'Yes', unchecked: 'No'}"/>
            </div>
            <small id="emailHelp" class="form-text text-muted">(shown as a dismissable notification, on login, to all users)</small>
        </div>


    </div>
</template>

<script>
	export default {
		props: [
		],
		data: function(){
			return {
			};
		},
        mounted() {

        },
        computed: {
            // usergroups: {
            //     get() {
            //         var value = [];
            //         for(var index in this.$parent.item.usersusergroupindex) {
            //             value.push(this.$parent.item.usersusergroup[index].user_id);
            //         }
            //         console.log(value);
            //         return value;
            //     },
            //     set() {
            //         this.$parent.item
            //     }
            // }
        },
        methods: {
            loadItem(id) {

                this.$parent.setLoading(true);
                axios.get(this.$parent.route + '/' + id).then((res) => {
                    this.$parent.item = res.data[this.$parent.model];
                    this.$parent.item.users = [];
                    for(var index in this.$parent.item.usersusergroup) {
                        this.$parent.item.users.push(this.$parent.item.usersusergroup[index].user_id);
                    }
                    this.$parent.setLoading(false);
                    //alert(JSON.stringify(this.$parent.item.users, null, 2));
				}).catch((error) => {
                    this.$parent.setLoading(false);
                    this.$parent.handleError(error, "load");
                    this.$router.push({path: "/" + this.$parent.event + "-list"});
                });
            },
            getName() {
                return "'" + this.$parent.item.title + "'";
            }
        }

    }
</script>
